import Script from 'next/script';

export interface DataScriptProps {
	id?: string;
	strategy?: 'afterInteractive' | 'beforeInteractive' | 'lazyOnload';
	data?: Record<string, unknown>;
	variableName?: string;
}

export const DataScript: React.FC<DataScriptProps> = ({ id, strategy, data, variableName }) => {
	const html = { __html: `window.${variableName} = ${JSON.stringify(data)};` };
	return <Script id={id} strategy={strategy} dangerouslySetInnerHTML={html} />;
};
